let required = (value) => {
  return !!value || "Requer o campo!";
};
let requiredEmail = () => { 
  return v => v && v.length > 0 || `Digite um E-mail.`
}
let requiredSenha = () => { 
  return v => v && v.length > 0 || `Digite uma Senha.`
}
let minLength = (minLength) => {
  return v => v && v.length >= minLength || `Digite o mínimo de ${minLength} caracteres.`
}
let maxLength = (maxLength) => {
  return v => v && v.length <= maxLength || `Digite o máximo de ${maxLength} caracteres.`
}
let emailFormat = () => {
  let regex = /^[a-zA-Z0-9\\.\\_\\-]+@[a-zA-Z0-9\\.\\_\\-]+$/
  return v => v && regex.test(v) || "Digite um e-mail válido."
}
let senhaRules = (minLength) => [
  (v) => !!v || "Digite uma Senha.",
  (v) => !/\s/.test(v) || "A senha não pode conter espaço.",
  (v) => v && v.length >= minLength || `Digite o mínimo de ${minLength} caracteres.`,
]
let noSpace = () => {
  return v => !/\s/.test(v) || "A senha não pode conter espaço."
}
let requeridoCampo = () => {
  return value => (value != null && value != "") || "Campo requerido!"
}
let requeridoAutocomplete = () => {
  return value => value != null || "Campo requerido!"
}
let dataRules = () => [
  (v) => !!v || "Data obrigatória!", 
  (v) => !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v) || "Data contêm formato inválido! Utilize o formato DD/MM/AAAA.",
  (v) => {
    if (!v) return true;
    const parts = v.split(' ');
    const date = parts[0];
    const [day, month, year] = date.split('/');
    const isValidDate = (month == 2 ? day >= 1 && day <= 29 : day >= 1 && day <= 31) && month >= 1 && month <= 12 && year.length === 4 && year >= 1900;
    return isValidDate || 'Data inválida!';
  }
]
let dataRulesNaoObrigatorio = () => [
  (v) => !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v) || "Data contêm formato inválido! Utilize o formato DD/MM/AAAA.",
  (v) => {
    if (!v) return true;
    const parts = v.split(' ');
    const date = parts[0];
    const [day, month, year] = date.split('/');
    const isValidDate = (month == 2 ? day >= 1 && day <= 29 : day >= 1 && day <= 31) && month >= 1 && month <= 12 && year.length === 4 && year >= 1900;
    return isValidDate || 'Data inválida!';
  }
]
let dataHorasRules = () => [
  (v) => !!v || "Data obrigatória!", 
  (v) => !v  || /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/.test(v) || 'Data e hora contêm formato inválido! Utilize o formato DD/MM/AAAA HH:MM.',
  (v) => {
    if (!v) return true;
    const parts = v.split(' ');
    const date = parts[0];
    const time = parts[1];
    const [day, month, year] = date.split('/');
    const [hours, minutes] = time.split(':');
    const isValidDate = (month == 2 ? day >= 1 && day <= 29 : day >= 1 && day <= 31) && month >= 1 && month <= 12 && year.length === 4 && year >= 1900;
    const isValidTime = hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
    return isValidDate && isValidTime || 'Data ou hora inválida!';
  }
]
let dataHorasRulesNaoObrigatorio = () => [
  (v) => !v  || /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/.test(v) || 'Data e hora contêm formato inválido! Utilize o formato DD/MM/AAAA HH:MM.',
  (v) => {
    if (!v) return true;
    const parts = v.split(' ');
    const date = parts[0];
    const time = parts[1];
    const [day, month, year] = date.split('/');
    const [hours, minutes] = time.split(':');
    const isValidDate = (month == 2 ? day >= 1 && day <= 29 : day >= 1 && day <= 31) && month >= 1 && month <= 12 && year.length === 4 && year >= 1900;
    const isValidTime = hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
    return isValidDate && isValidTime || 'Data ou hora inválida!';
  }
]

export default {
  requiredEmail,
  requiredSenha,
  required,
  minLength,
  maxLength,
  emailFormat,
  senhaRules,
  noSpace,
  requeridoCampo,
  requeridoAutocomplete,
  dataRules,
  dataRulesNaoObrigatorio,
  dataHorasRules,
  dataHorasRulesNaoObrigatorio,
}